var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('download-csv',{attrs:{"data":_vm.data,"name":_vm.fileName,"fields":_vm.fields,"labels":_vm.labels}},[_c('v-btn',_vm._b({attrs:{"outlined":"","color":"#424242"}},'v-btn',_vm.size,false),[_c('v-icon',[_vm._v("mdi-file-table")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }